import {getApi, postApi} from "../../data/ApiService";
import {GET_CONTACT_US, POST_CONTACT_US} from "../aboutManagement/action_type";
import {SET_CONTACT_US, SET_LOADING} from "../aboutManagement/mutation_types";
import {SET_ERROR} from "../eventManagement/mutation_types";

const state = {
    loading: false,
    error: {},
    glassVideo:{},
    glassHomeBanner: {},
    glassHomeCatalogue: {},
    glassHomeFeatures: {},
    glassNews: {},
    glassProjects: {},
    glassProducts: {},
    glass_quality_hints:[],
    companyIntro: {},
    production_lines:[],
    exports: {},
    management: {},
    buildStructure: {},
    representation: {},
    agencies: {},
    agenciesForm: {},
    glassArticles: {},
    glassCertificates: {},
    glassEvents: {},
    glassGallery: {},
    glassBanners: null,
    contactUsForm: null,
    products: null,
    productDetails: null,
    glassNewsSlider:[]
}

const actions = {
    async getGlassNewsSlider({commit}){
        commit('setLoading', true);
        try {
            const response = await getApi('category/209/page/1/count/100');
            state.glassNewsSlider=response.data;
        }
        catch (e) {
            commit('setError',e.response.message);
        }
        finally {
            commit('setLoading', false);
        }
    },
    async getContactUs({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('topics/11/fields');
            console.log(response);
            commit('setContactUs', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async PostContactUs({commit}, payload) {
        commit('setLoading', true);
        try {
            const response = await postApi('topics/27', payload);
            console.log(response);
            // commit(SET_CONTACT_US,response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },

    async getGlassBanners({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/131/page/1/count/1000');
            commit('setGlassBanners', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassHomeBanner({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/133/page/1/count/100');
            commit('setGlassHomeBanner', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassHomeCatalogue({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/130/page/1/count/100');
            commit('setGlassHomeCatalogue', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassHomeFeatures({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/37/page/1/count/100');
            commit('setGlassHomeFeatures', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassNews({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/98/page/${payload.page}/count/${limit}`);
            commit('setGlassNews', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassEvents({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/95/page/${payload.page}/count/${limit}`);
            commit('setGlassEvents', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassVideo({commit}) {
        commit('setLoading', true);
        try {
            const {data} = await getApi('banners/13');
            state.glassVideo=data.banners[0];
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassProductionLines({commit}) {
        commit('setLoading', true);
        try {
            const {data} = await getApi('banners/14');
            state.production_lines=data.banners;
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassQualityHints({commit}) {
        commit('setLoading', true);
        try {
            const {data} = await getApi('banners/15');
            state.glass_quality_hints=data.banners;
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassGallery({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/97/page/${payload.page}/count/${limit}`);
            commit('setGlassGallery', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassArticles({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/267/page/1/count/100');
            commit('setGlassArticles', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassCertificates({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/128/page/1/count/100');
            commit('setGlassCertificates', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassProjects({commit},payload) {
        commit('setLoading', true);
        try {
            let limit=payload.limit || 10;
            const response = await getApi(`category/96/page/${payload.page}/count/${limit}`);
            commit('setGlassProjects', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getCompanyIntro({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/218/page/1/count/100');
            commit('setCompanyIntro', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getManagement({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/219/page/1/count/100');
            commit('setManagement', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassExport({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/220/page/1/count/100');
            commit('setGlassExport', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },

    async getAgenciesDetails({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('topic/93');
            commit('setAgenciesDetails', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getAgenciesForm({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('topics/23/fields');
            commit('setAgenciesForm', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getRepresentation({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/46/page/1/count/100');
            commit('setRepresentation', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },


    async getGlassProducts({commit}) {
        commit('setLoading', true);
        try {


            const response = await getApi('categories/8');

            var products = [
                {
                    title: response.data.categories[10].title,
                    id:response.data.categories[10].id,
                    photo_file: response.data.categories[10].photo,
                    sub: response.data.categories[10].sub_categories,
                },
                {
                    title: response.data.categories[1].title,
                    id:response.data.categories[1].id,
                    photo_file: response.data.categories[1].photo,
                    sub: response.data.categories[1].sub_categories,
                },
                {
                    title: response.data.categories[8].title,
                    id:response.data.categories[8].id,
                    photo_file: response.data.categories[8].photo,
                    sub: response.data.categories[8].sub_categories,
                },
                {
                    title: response.data.categories[9].title,
                    id: response.data.categories[9].id,
                    photo_file: response.data.categories[9].photo,
                    sub: response.data.categories[9].sub_categories,
                },

            ];
            commit('setGlassProducts', products);
            console.log('products', products);


        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getGlassProductDetail({commit},payload) {
        commit('setLoading', true);
        try {

            console.log('details is');
            const response = await getApi(`topics/cat/${payload.id}`);

            commit('setGlassProductDetails', response);
            console.log('productDetails', response);


        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },


}

const mutations = {
    setContactUs(state, resource) {
        state.contactUsForm = resource.data;
    },
    setGlassBanners(state, resource) {
        state.glassBanners = resource.data.topics;
    },
    setGlassHomeBanner(state, resource) {
        state.glassHomeBanner = resource.data.topics;
    },
    setGlassHomeCatalogue(state, resource) {
        state.glassHomeCatalogue = resource.data;
    },
    setGlassHomeFeatures(state, resource) {
        state.glassHomeFeatures = resource.data;
    },
    setGlassNews(state, resource) {
        state.glassNews = resource.data;
    },
    setGlassEvents(state, resource) {
        state.glassEvents = resource.data;
    },
    setGlassGallery(state, resource) {
        state.glassGallery = resource.data;
    },
    setGlassProjects(state, resource) {
        state.glassProjects = resource.data;
    },
    setGlassProducts(state, resource) {
        state.products = resource;
    },
    setGlassProductDetails(state, resource) {
        state.productDetails = resource.data;
    },
    setCompanyIntro(state, resource) {
        state.companyIntro = resource.data;
    },
    setManagement(state, resource) {
        state.management = resource.data;
    },
    setGlassExport(state, resource) {
        state.exports = resource.data;
    },
    setRepresentation(state, resource) {
        state.representation = resource.data;
    },
    setAgenciesDetails(state, resource) {
        state.agencies = resource.data;
    },
    setAgenciesForm(state, resource) {
        state.agenciesForm = resource.data.data;
    },
    setGlassArticles(state, resource) {
        state.glassArticles = resource.data;
    },
    setGlassCertificates(state, resource) {
        state.glassCertificates = resource.data;
    },


    setLoading(state, loading) {
        state.loading = loading;
    },
    setError(state, error) {
        state.error = error;
    }
}

const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}